import type { ReactFile } from "schemas/generated/reactFile";

export const getSandpackFilePath = (file: ReactFile) => {
  if (file.fileType === "component") {
    return `/src/components${file.relativePath === "/" ? "" : file.relativePath}/${file.fileName}`;
  } else {
    if (file.relativePath === "/") {
      return `/src/pages/${file.fileName}`;
    }
    return `/src/pages${file.relativePath === "/" ? "" : file.relativePath}/${file.fileName}`;
  }
};

export const findPageFileFromPath = (path: string, files: ReactFile[]) => {
  return files.find((f) => f.relativePath === path && f.fileType === "page");
};
